import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectSupplierAllocations,
  selectSupplierAllocationsError,
  selectSupplierAllocationsLoading,
  selectSupplierAllocationsUpdateStatus,
  selectSupplierAllocationsUpdating,
  selectSupplierBlends,
  selectSupplierBlendsError,
  selectSupplierBlendsLoading,
  selectSupplierGroupTemplates,
  selectSupplierGroupTemplatesLoading,
  selectSupplierFlexibilityPriceParams,
  selectSupplierFlexibilityPriceParamsError,
  selectSupplierFlexibilityPriceParamsLoading,
  selectSupplierGroupTemplateSaveError,
  selectSupplierGroupTemplateSaving,
  selectSupplierBlendSaving,
  selectSupplierSavedBlendId,
  selectSupplierRateCards,
  selectSupplierRateCardsLoading,
  selectSupplierRateCardsError,
} from './supplier.selectors';

@Injectable({ providedIn: 'root' })
export class SupplierSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly allocations = this._store.selectSignal(
    selectSupplierAllocations,
  );

  public readonly allocationsLoading = this._store.selectSignal(
    selectSupplierAllocationsLoading,
  );

  public readonly allocationsError = this._store.selectSignal(
    selectSupplierAllocationsError,
  );

  public readonly allocationsUpdating = this._store.selectSignal(
    selectSupplierAllocationsUpdating,
  );

  public readonly allocationsUpdateStatus = this._store.selectSignal(
    selectSupplierAllocationsUpdateStatus,
  );

  public readonly blends = this._store.selectSignal(selectSupplierBlends);

  public readonly blendsLoading = this._store.selectSignal(
    selectSupplierBlendsLoading,
  );

  public readonly blendsError = this._store.selectSignal(
    selectSupplierBlendsError,
  );

  public readonly groupTemplates = this._store.selectSignal(
    selectSupplierGroupTemplates,
  );

  public readonly groupTemplatesLoading = this._store.selectSignal(
    selectSupplierGroupTemplatesLoading,
  );

  public readonly flexibilityPriceParams = this._store.selectSignal(
    selectSupplierFlexibilityPriceParams,
  );

  public readonly flexibilityPriceParamsLoading = this._store.selectSignal(
    selectSupplierFlexibilityPriceParamsLoading,
  );

  public readonly flexibilityPriceParamsError = this._store.selectSignal(
    selectSupplierFlexibilityPriceParamsError,
  );

  public readonly groupTemplateSaving = this._store.selectSignal(
    selectSupplierGroupTemplateSaving,
  );

  public readonly groupTemplateSaveError = this._store.selectSignal(
    selectSupplierGroupTemplateSaveError,
  );

  public readonly blendSaving = this._store.selectSignal(
    selectSupplierBlendSaving,
  );

  public readonly savedBlendId = this._store.selectSignal(
    selectSupplierSavedBlendId,
  );

  public readonly rateCards = this._store.selectSignal(selectSupplierRateCards);

  public readonly rateCardsLoading = this._store.selectSignal(
    selectSupplierRateCardsLoading,
  );

  public readonly rateCardsError = this._store.selectSignal(
    selectSupplierRateCardsError,
  );
}
